import { useEffect } from 'react';

/**
 * Custom hook to restore table visibility after save
 * Listens for 'soe-restore-visibility' event and opens the table if it matches the target component
 * 
 * @param {string} tableName - The name of the table to restore (must match data-table-name attribute)
 * @param {function} setIsExpanded - State setter to control table expansion
 */
export function useRestoreTableVisibility(tableName, setIsExpanded) {
  useEffect(() => {
    const handleRestoreVisibility = (event) => {
      // Get componentName from event detail
      const componentName = event.detail?.componentName;
      
      if (componentName && componentName === tableName) {
        setIsExpanded(true);
      }
    };

    window.addEventListener('soe-restore-visibility', handleRestoreVisibility);
    return () => {
      window.removeEventListener('soe-restore-visibility', handleRestoreVisibility);
    };
  }, [tableName, setIsExpanded]);
}
